import {load_products} from './product-catalog'
import {open_collapse} from './../../organisms/filter-collapse'

(function ($) {

	let $form = $('form.product-catalog-filters'),
		delay

	function get_ajax_url(url) {
		let first = true,
			filters = get_active_filters()

		// Add filters if set
		if (filters) {
			for (const [key, value] of Object.entries(filters)) {
				if (value) {
					if (first) {
						first = false
						url += "?"
					} else {
						url += "&"
					}

					url += key + "=" + value
				}
			}
		}

		return url;
	}

	function open_dropdown(event, data) {
		if (window.innerWidth < 768) {
			// Open sidebar instead
			data.open_dropdown = false
			$(document).trigger("open_modal", "product-catalog-filtration")
			let $filter = $('.sidebar-product-catalog-filtration').find("[data-filter='" + data.filter + "']")
			open_collapse($filter)
		}
	}

	$(document).on('open_filter_dropdown', open_dropdown)

	function sync_forms() {
		// Sync checkboxes, radio buttons
		$form.find("input[type='checkbox'], input[type='radio']").change(function () {
			let name = $(this).attr("name")
			let value = $(this).attr("value")
			let is_checked = $(this).is(":checked")
			$form.find("[name='" + name + "'][value='" + value + "']").prop("checked", is_checked)
		})
	}

	sync_forms()

	function get_active_filters() {

		// Get data from form
		var form_data = $form.serializeArray()
		form_data = form_data.filter((item, index, array) =>
				index === array.findIndex((obj) =>
					obj.name === item.name && obj.value === item.value
				)
		)

		// Reset filters object
		let filters = {}

		form_data.forEach(function (item) {
			// Set price_from & price_to only if less/greater than min (default) value
			if (item.name == 'price_from') {
				if (item.value > parseInt($("input[name='price_from']").attr('min'))) {
					filters[item.name] = item.value
				}
			} else if (item.name == 'price_to') {
				if (item.value < parseInt($("input[name='price_to']").attr('max'))) {
					filters[item.name] = item.value
				}
			} else if (filters[item.name]) {
				// Set 2nd and next value
				filters[item.name] += "," + item.value
			} else {
				// Set 1st value
				filters[item.name] = item.value
			}
		})

		return filters
	}

	function set_active_filters() {
		set_active_dropdown_filters()
		set_active_collapse_filters()
	}

	set_active_filters()

	function set_active_dropdown_filters() {

		// Add selected checkboxes filter labels
		let $active_filters = $form.eq(0).find("input[type='checkbox']:checked, input[type='radio']:checked")
		let $active_filters_container = $('.product-catalog-filtration__filtered')
		let active_filters = 0

		// Empty container
		$active_filters_container.empty()


		$active_filters.each(function () {

			if ($(this).val() !== "") {
				active_filters++
				let title = $(this).data('title')

				let active_button = "<button class=\"control-btn control-btn--outline\" type=\"button\">\n" +
					"<span class=\"control-btn__label\">" + title + "</span>\n" +
					"<svg width=\"13\" height=\"14\" viewBox=\"0 0 13 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
					"    <path d=\"M12.2474 1.25L1.16406 12.3333\" stroke=\"#734378\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n" +
					"    <path d=\"M1.16406 1.25L12.2474 12.3333\" stroke=\"#734378\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n" +
					"</svg>\n" +
					"</button>"

				let new_label = $(active_button).appendTo($active_filters_container)
				new_label.data('checkbox', $(this))
				// Bind click to remove
				new_label.click(function () {
					let $checkbox = $(this).data('checkbox')
					uncheck_filter($checkbox.attr("name"), $checkbox.attr("value"))
					$form.trigger("change")
				})
			}

		})

		// Add active filter class and "Clear all filters" button
		if (active_filters > 1) {
			let reset_button = $("<button class=\"btn btn__tertiary btn__size-m btn__icon-right\"><span>Smazat filtry</span></button>").appendTo($active_filters_container)
			reset_button.click(reset_filters)
		}

	}

	function set_active_collapse_filters() {

		$(".filter-collapse").each(function () {

			let $active_filters = $(this).find("input[type='checkbox']:checked, input[type='radio']:checked")

			let filtered = []
			$active_filters.each(function () {
				if ($(this).val() !== "" && $(this).data('title') !== "") {
					filtered.push($(this).data('title'))
				}
			})

			let $filtered_container = $(this).find('.filter-collapse__filtered')

			if (filtered.length > 0) {
				$filtered_container.text(filtered.join(', '))
			} else {
				$filtered_container.empty()
			}

		})

	}

	function uncheck_filter(name, value) {
		$form.find("[name='" + name + "'][value='" + value + "']").prop("checked", false)
	}

	function reset_filters() {

		// Reset checkboxes
		$form.find("input[type='checkbox'], input[type='radio']").prop("checked", false)

		// Reset range
		// var price_min = $price_slider[0].data('slider-min'),
		// 	price_max = $price_slider[0].data('slider-max')
		//
		// $price_slider[0].bootstrapSlider('setValue', [price_min, price_max]);
		// $price_slider[0].trigger('change')

		// Update form
		$form.trigger('change')
	}

	$('[data-reset-filters]').click(reset_filters)

	function form_changed() {

		// Set active filters
		set_active_filters()

		// Clear timeout to prevent spam
		clearTimeout(delay)

		// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
		delay = setTimeout(() => {
			let url_base = $(this).attr('action')
			load_products(get_ajax_url(url_base), false)
		}, 500)
	}

	$form.on('change', form_changed)

	return

	// // Elements
	// let $filters_form = $('form.product-catalog-filters'),
	// 	$active_filters_container = $('.product-catalog-filtration__filtered'),
	// 	$reset_filters_sidebar_btn = $('.archive-product-filter-clear')
	//
	// // Prevent filters spam
	// let timeout;
	//
	// $form.change(function () {w
	//
	// 	// Clear timeout to prevent spam
	// 	clearTimeout(timeout)
	//
	// 	// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
	// 	timeout = setTimeout(() => {
	// 		let url_base = $filters_form.attr('action')
	// 		load_products(get_ajax_url(url_base), false)
	// 	}, 500)
	//
	// })
	//
	//
	// // $ordering_option.click(function (e) {
	// // 	e.preventDefault()
	// // 	$('.orderby_option.active').removeClass('active')
	// // 	$(this).addClass('active')
	// // 	$filters_form.trigger('change')
	// // })
	//
	// // Sidebar filters form - clear filters
	// $reset_filters_sidebar_btn.on("click", function (e) {
	// 	e.preventDefault();
	// 	reset_filters(e)
	// 	$(document).trigger("close_modal", "filters")
	// })
	//
	//
	// function reset_filters(e) {
	// 	e.preventDefault()
	// 	// Reset checkboxes
	// 	$("input[type='checkbox']").prop("checked", false)
	// 	// Reset price
	// 	$filters_form.trigger('change')
	// }
	//
	//
	// function get_new_url(base = false) {
	//
	// 	let url = base,
	// 		first = true,
	// 		filters = get_active_filters()
	//
	// 	// Add filters if set
	// 	if (filters) {
	// 		for (const [key, value] of Object.entries(filters)) {
	// 			if (value) {
	// 				if (first) {
	// 					first = false
	// 					url += "?"
	// 				} else {
	// 					url += "&"
	// 				}
	//
	// 				url += key + "=" + value
	// 			}
	// 		}
	// 	}
	//
	// 	return url;
	// }
	//
	// function set_active_filters() {
	// 	set_site_active_filters()
	// 	set_sidebar_active_filters()
	// }
	//
	// function set_site_active_filters() {
	//
	// 	$active_filters_container.empty()
	// 	let active_filters = 0;
	//
	// 	if ($price_slider.length > 0) {
	//
	// 		let $myslider = $price_slider[0]
	//
	// 		// Add price range slider labels
	// 		var range_price = $myslider.bootstrapSlider('getValue')
	//
	// 		var price_from = range_price[0],
	// 			price_min = $myslider.data('slider-min'),
	// 			price_to = range_price[1],
	// 			price_max = $myslider.data('slider-max')
	//
	// 		// From
	// 		if (price_from != price_min) {
	// 			active_filters++
	// 			var price_from_label = $("<button class=\"products_archive__filtered-btn\">Od: " + price_from + " Kč</button>").appendTo($active_filters_container)
	// 			// Bind click to remove
	// 			price_from_label.click(function () {
	// 				$myslider.bootstrapSlider('setValue', [price_min, price_to]);
	// 				$myslider.trigger('change')
	// 				$filters_form.trigger('change')
	// 			})
	// 		}
	//
	// 		// To
	// 		if (price_to != price_max) {
	// 			active_filters++
	// 			var price_to_label = $("<button class=\"products_archive__filtered-btn\">Do: " + price_to + " Kč</button>").appendTo($active_filters_container)
	// 			// Bind click to remove
	// 			price_to_label.click(function () {
	// 				$myslider.bootstrapSlider('setValue', [price_from, price_max]);
	// 				$myslider.trigger('change')
	// 				$filters_form.trigger('change')
	// 			})
	// 		}
	// 	}
	//
	// 	// Add selected checkboxes filter labels
	// 	var $active_filters = $filters_form.eq(0).find("input[type='checkbox']:checked, input[type='radio']:checked")
	//
	// 	$active_filters.each(function () {
	//
	// 		if ($(this).val() !== "") {
	// 			active_filters++
	// 			var new_label = $("<button class=\"products_archive__filtered-btn\">" + $(this).data('label') + "</button>").appendTo($active_filters_container)
	// 			new_label.data('checkbox', $(this))
	// 			// Bind click to remove
	// 			new_label.click(function () {
	// 				let $checkbox = $(this).data('checkbox')
	// 				uncheck_filter($checkbox.attr("name"), $checkbox.attr("value"))
	// 				$filters_form.trigger("change")
	// 			})
	// 		}
	//
	// 	})
	//
	// 	// Add active filter class and "Clear all filters" button
	// 	if (active_filters > 0) {
	// 		$active_filters_container.addClass('products_archive__filtered-use');
	// 		$("<button class=\"products_archive__filtered-clear archive-product-filter-reset\">" + $('.products_archive__filtered').data('clear-text') + "</button>").appendTo($active_filters_container)
	// 	} else {
	// 		$active_filters_container.removeClass('products_archive__filtered-use');
	// 	}
	//
	// 	// Bind reset
	// 	$('.archive-product-filter-reset').click(reset_filters)
	//
	// }
	//
	// function set_sidebar_active_filters() {
	// 	$(".sidebar__filters__filter, .sidebar__filters-form .products_archive__filter-order").each(function () {
	// 		let $active_filters = $(this).find("input[type='checkbox']:checked, input[type='radio']:checked")
	// 		let active_filters = []
	// 		$active_filters.each(function () {
	// 			active_filters.push($(this).data("label"))
	// 		})
	// 		$(this).find(".products_archive__filter-result").text(active_filters.join(", "))
	// 	})
	// }
	//
	// // function set_active_labels() {
	// //
	// // 	$active_filters_container.empty()
	// //
	// // 	// Add selected checkboxes filter labels
	// // 	let $active_filters = $filters_form.find("input[type='checkbox']:checked")
	// // 	$active_filters.each(function () {
	// // 		let new_label = $("<button class=\"products_archive__filtered-btn\">" + $(this).data('label') + "</button>").appendTo($active_filters_container)
	// // 		new_label.data('checkbox', $(this))
	// // 		// Bind click to remove
	// // 		new_label.click(function () {
	// // 			$(this).data('checkbox').prop("checked", false)
	// // 			$filters_form.trigger('change')
	// // 		})
	// // 	})
	// //
	// // }
	//
	// $(document).gp_ready(set_active_filters)

})(jQuery);